import { useDispatch, useSelector } from "react-redux";

import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tooltip
} from "@mui/material";

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import HomeIcon from "@mui/icons-material/Home";
import LegendToggleIcon from '@mui/icons-material/LegendToggle';

import {useNavigate } from "react-router-dom";
import { authSelector } from "../../../features/auth/authSlice";
import {
    displaySelector,
    setIsDisplaySidebar
} from "../../../features/display/displaySlice";


import styles from "../../../styles/toolsbar.module.css";

/** ------------------------------------------------------------------------  */  
const Toolsbar = () => {
  const { isAuth, user } = useSelector(authSelector);
  const display = useSelector(displaySelector);
  
  const dispatch = useDispatch();

  const toggleDisplaySidebar = () => {
      dispatch(setIsDisplaySidebar( !display.isDisplaySidebar))
  } 

  let navigate = useNavigate();

  return (
    <>
    <nav className={styles.toolsbar}>
      {isAuth && (
        <List className={styles.navList}>

          <ListItem disablePadding>
            <ListItemButton onClick={() => toggleDisplaySidebar()} className={styles.listTools}>
              <ListItemIcon>
                <Tooltip title="Plein écran" placement="right" arrow>
                  <IconButton>
                    <FullscreenIcon />
                  </IconButton>
                </Tooltip>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          {display.isDisplaySidebar === false && (
            <>
          <ListItem disablePadding>
            <ListItemButton onClick={() => navigate("/")} className={styles.listTools}>
              <ListItemIcon>
                <Tooltip title="Accueil" placement="right" arrow>
                <IconButton>
                  <HomeIcon />
                </IconButton>
                </Tooltip>
              </ListItemIcon>
            </ListItemButton>
            </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => { navigate("/monitoring") }} className={styles.listTools}>
              <ListItemIcon>
                <Tooltip title="Espace monitoring" placement="right" arrow>
                  <IconButton>
                    <LegendToggleIcon />
                  </IconButton>
                </Tooltip>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>

          {user?.roles?.includes('biotech-supervision-admin') && (
            <ListItem disablePadding>
              <ListItemButton onClick={() => { navigate("/adminspace") }} className={styles.listTools}>
                <ListItemIcon>
                  <Tooltip title="Espace Administration" placement="right" arrow>
                    <IconButton>
                      <AdminPanelSettingsIcon />
                    </IconButton>
                  </Tooltip>
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          )}

          </>
          )}

        </List>
      )}

    </nav>
    </>
  );
};

export default Toolsbar;
  